import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.298 6.372a.42.42 0 0 0-.594.001l-2.925 2.925a2.92 2.92 0 0 1-2.066.857h-4.136a.42.42 0 0 0-.422.421v4.175c0 .749-.297 1.465-.826 1.994l-2.956 2.956a.42.42 0 0 0 0 .595L9.3 23.22c.547.547.856 1.29.856 2.065v4.137c0 .233.189.422.422.422h4.135a2.9 2.9 0 0 1 2.069.861l.003.003 2.92 2.92.001.001a.42.42 0 0 0 .594-.001l2.925-2.925a2.92 2.92 0 0 1 2.066-.856h4.137a.42.42 0 0 0 .421-.422V25.29c0-.776.31-1.519.856-2.066l2.925-2.925.002-.001a.42.42 0 0 0-.002-.594l-2.925-2.925a2.92 2.92 0 0 1-.856-2.066v-4.137a.42.42 0 0 0-.421-.421H25.29c-.776 0-1.519-.31-2.066-.857zm1.77-1.765 2.924 2.924c.08.08.187.124.298.124h4.137a2.92 2.92 0 0 1 2.921 2.921v4.137c0 .11.044.218.124.298l2.925 2.925a2.92 2.92 0 0 1 0 4.132l-2.925 2.924a.42.42 0 0 0-.124.298v4.136a2.92 2.92 0 0 1-2.921 2.922H25.29a.42.42 0 0 0-.298.124l-2.925 2.925a2.92 2.92 0 0 1-4.132-.001l-2.924-2.924-.004-.005a.4.4 0 0 0-.295-.122h-4.135a2.92 2.92 0 0 1-2.922-2.922v-4.137a.42.42 0 0 0-.124-.298l-2.925-2.924a2.92 2.92 0 0 1 0-4.132l2.955-2.955a.32.32 0 0 0 .094-.226v-4.175a2.92 2.92 0 0 1 2.922-2.921h4.136c.111 0 .218-.045.298-.124l2.925-2.925a2.92 2.92 0 0 1 4.132 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M25.884 16.616a1.25 1.25 0 0 1 0 1.768l-6.25 6.25a1.25 1.25 0 0 1-1.768 0l-3.75-3.75a1.25 1.25 0 0 1 1.768-1.768l2.866 2.866 5.366-5.366a1.25 1.25 0 0 1 1.768 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }